import type { Dict } from "../types";

export const payroll: Dict = {
  en: {

    // Payroll toast messages (errorToast / successToast wrapper)
    "Payroll.toast.savePunchFailed": "Could not save punch",
    "Payroll.toast.savePinFailed": "Could not save PIN",
    "Payroll.toast.pinCreated": "PIN created",
    "Payroll.toast.fixTimeInvalid": "Punch out time must be after punch in time.",
    "Payroll.toast.scheduleApplied": "Schedule applied",
    "Payroll.toast.auditWarning": "Timesheet saved but audit log failed",
    "Payroll.toast.auditWarningDesc": "Some audit entries could not be recorded. Contact support if this persists.",
    "Payroll.toast.recalculated": "Recalculated",
    "Payroll.toast.finalized": "Finalized",

    // Additional Payroll toast messages
    "Payroll.toast.deleteDeductionFailed": "Could not delete the deduction",
    "Payroll.toast.punchInFailed": "Could not punch in",
    "Payroll.toast.punchOutFailed": "Could not punch out",
    "Payroll.toast.resetPinFailed": "Could not reset the PIN",
    "Payroll.toast.saveDeductionFailed": "Could not save the deduction",

    // D8 : panne technique de l'export (500), distincte d'un refus de droits (403).
    "Payroll.exportTemporaryError": "Temporary error, please try again.",
    "Payroll.presenceMapError": "Could not check which pays combine several locations. Their details stay closed until this check succeeds.",
    "Payroll.bulkNothingToPrint": "Nothing to print for this period: the pays of people working in several locations are printed once finalized.",

    // Payroll Module
    "Payroll.title": "Payroll",
    "Payroll.subtitle": "Employee payroll management",
    "Payroll.subtitleOwn": "Your pay",
    "Payroll.ownTab": "My pay",
    "Payroll.noOwnFiche": "No employee record is linked to your account in this salon.",
    "Payroll.noAccessTitle": "No access",
    "Payroll.noAccessDescription": "You do not have permission to view payroll. Contact the salon owner to request access.",
    "Payroll.noEmployees": "No employees found. Add employees first.",
    "Payroll.notConfigured": "Not configured",
    "Payroll.timesheet": "Timesheet",
    "Payroll.auditWarning": "Timesheet saved but audit log failed",
    "Payroll.auditWarningDesc": "Some audit entries could not be recorded. Contact support if this persists.",
    "Payroll.report": "Report",
    "Payroll.salaryType": "Salary Type",
    "Payroll.hourly": "Hourly",
    "Payroll.commission": "Commission",
    "Payroll.hourlyCommission": "Hourly + Commission",
    "Payroll.fixed": "Fixed",
    "Payroll.hourlyRate": "Hourly Rate",
    "Payroll.fixedSalary": "Fixed Salary",
    "Payroll.fixedSalaryUnit": "Paid per",
    "Payroll.fixedUnitPerPeriod": "Pay period",
    "Payroll.fixedUnitWeekly": "Week",
    "Payroll.fixedUnitBiweekly": "2 weeks",
    "Payroll.fixedUnitMonthly": "Month",
    "Payroll.fixedUnitYearly": "Year",
    "Payroll.regularHoursPerWeek": "Regular Hours/Week",
    "Payroll.overtimeMultiplier": "Overtime Multiplier",
    "Payroll.deductions": "Deductions",
    "Payroll.dailyDeduction": "Daily Deduction",
    "Payroll.payDeductionPercent": "% per Pay",

    // Commission tiers (owner-configured scale per employee and category)
    "Payroll.commissionCategory.service": "Services",
    "Payroll.commissionCategory.product": "Products",
    "Payroll.commissionCategory.other": "Other",
    "Payroll.commissionThreshold": "Threshold before commission",
    "Payroll.commissionTierN": "Tier {n}",
    "Payroll.commissionTierUpTo": "Up to",
    "Payroll.commissionTierBeyond": "and above",
    "Payroll.commissionTierAdd": "Add a tier",
    "Payroll.commissionTierRemove": "Remove this tier",
    "Payroll.commissionTierRate": "Rate",
    "Payroll.commissionPreviewTotal": "Commission for the period",
    "Payroll.tipsThroughPayroll": "Pay tips through payroll",
    "Payroll.tipsThroughPayrollOn": "Tips appear on the pay stub and count toward the amount to pay.",
    "Payroll.tipsThroughPayrollOff": "Tips stay out of payroll. The stub shows them for information, outside the total.",
    "Payroll.commissionTierUnreadable": "An amount cannot be read, so this scale is not saved. Enter digits only, with at most two decimals, for example 1000 or 1000.50.",
    "Payroll.reportContextError": "The payroll data for this employee could not be loaded, so this report cannot be finalized. Close it and open it again to retry.",
    "Payroll.liveDataErrorTitle": "Payroll could not be calculated",
    "Payroll.liveDataErrorDescription": "Some data could not be loaded. No amount is shown to avoid a wrong total. Please try again.",

    // Tiered commission breakdown on the pay stub
    "Payroll.tierBreakdownTitle": "Tiered commission",
    "Payroll.tierBand": "Cumulative bracket",
    "Payroll.tierBelowThreshold": "Below threshold",
    "Payroll.tierAdjustedAmount": "Adjusted amount",
    "Payroll.tierNonCommissionable": "Non-commissionable portion",
    "Payroll.tierCalculatedOnPeriod": "Tiered scale calculated on the period total, not per week",
    "Payroll.tipsOutsidePayroll": "Tips paid outside payroll",
    "Payroll.tipsNotInTotal": "excluded from the total",

    "Payroll.productCommission": "Product Commission",
    "Payroll.serviceCommission": "Service Commission",
    "Payroll.configSaved": "Configuration saved",
    "Payroll.configError": "Error saving configuration",
    "Payroll.period": "Period",
    "Payroll.date": "Date",
    "Payroll.startTime": "Start",
    "Payroll.endTime": "End",
    "Payroll.lunch": "Lunch",
    "Payroll.break": "Break",
    "Payroll.total": "Total",
    "Payroll.totalHours": "Total Hours",
    "Payroll.week": "Week",
    "Payroll.timesheetSaved": "Timesheet saved",
    "Payroll.timesheetError": "Error saving timesheet",
    "Payroll.payrollReport": "Payroll Report",
    "Payroll.fixedSalarySection": "FIXED SALARY",
    "Payroll.fixedSalaryForPeriod": "Fixed salary for the period",
    "Payroll.hourlyRevenueSection": "HOURLY REVENUE",
    "Payroll.timesheetSection": "TIMESHEET",
    "Payroll.regularHours": "Regular Hours",
    "Payroll.overtimeHours": "Overtime",
    "Payroll.weekTotal": "Week total",
    "Payroll.totalHoursAllWeeks": "Total all weeks",
    "Payroll.tipsSection": "TIPS",
    "Payroll.tips": "Tips",
    "Payroll.commissionSection": "COMMISSIONS",
    "Payroll.revenue": "Revenue",
    "Payroll.cost": "Cost",
    "Payroll.internalProducts": "Internal Products",
    "Payroll.totalHourlySalary": "Hourly Salary",
    "Payroll.grandTotal": "GRAND TOTAL",
    "Payroll.generatedOn": "Generated",
    "Payroll.downloadPDF": "Print / PDF",
    "Payroll.history": "History",
    "Payroll.finalize": "Finalize",
    "Payroll.finalizeAll": "Finalize all",
    "Payroll.finalizeConfirm": "Finalize payroll for",
    "Payroll.finalizeWarning": "Timesheets for this period will be locked as read-only.",
    "Payroll.finalized": "Finalized",
    "Payroll.finalizedAt": "Finalized on",
    "Payroll.finalizedBy": "by",
    "Payroll.draft": "Draft",
    "Payroll.periodLocked": "Period finalized: read only",
    "Payroll.fillFromSchedule": "Fill from schedule",
    "Payroll.fillFromScheduleDone": "Schedule applied",
    "Payroll.daysFilled": "days filled from schedule",
    "Payroll.noDaysToFill": "No empty days matched the schedule",
    "Payroll.importScheduleForPeriod": "Import scheduled hours",
    "Payroll.importScheduleDialogTitle": "Import hours from the schedule",
    "Payroll.importScheduleDialogDescription": "This imports the scheduled hours for the whole team over the selected pay period. Review the details below before confirming.",
    "Payroll.importScheduleConfirm": "Confirm import",
    // Deux comptes dans une seule phrase : `pluralize` n'en accorde qu'un.
    // La tournure vaut donc au singulier comme au pluriel.
    "Payroll.importScheduleWillCreate": "Days to create: {days}. Employees affected: {employees}.",
    "Payroll.importScheduleSkippedExistingOne": "1 day already has an entry and will be left untouched",
    "Payroll.importScheduleSkippedExisting": "{count} days already have an entry and will be left untouched",
    "Payroll.importScheduleSkippedLockedOne": "1 day belongs to a finalized pay and cannot be changed",
    "Payroll.importScheduleSkippedLocked": "{count} days belong to a finalized pay and cannot be changed",
    "Payroll.importScheduleLunchWarning": "Imported hours come from your schedule. If your meal break is not blocked on the calendar, it will not be deducted: review those days before finalizing payroll.",
    "Payroll.importScheduleNothing": "Nothing to import: every scheduled day already has an entry.",
    // Bilan RÉEL de l'import, compté sur les lignes rendues par la base, jamais
    // sur le plan : une ligne peut naître entre la lecture et l'écriture.
    "Payroll.importScheduleDoneOne": "1 day was imported.",
    "Payroll.importScheduleDone": "{count} days were imported.",
    "Payroll.importScheduleDoneNone": "No day was imported: they all already had an entry.",
    "Payroll.sourceSchedule": "From schedule",
    "Payroll.exportAll": "Export all (ZIP)",
    "Payroll.downloadPdf": "Download PDF",
    "Payroll.filterEmployee": "Employee",
    "Payroll.filterYear": "Year",
    "Payroll.noRunsFound": "No payroll records found for this period.",
    "Payroll.finalizeAllConfirm": "Finalize payroll for all employees for this period?",
    "Payroll.generateReport": "Generate Report",
    "Payroll.punchInOut": "Punch In / Out",
    "Payroll.punchInOutDesc": "Enter your personal PIN to punch in or out.",
    "Payroll.punchClock": "Punch Clock",
    "Payroll.punchClockDesc": "Enter your four digit PIN to record your punch in or punch out.",
    "Payroll.punchIn": "Punch In",
    "Payroll.punchOut": "Punch Out",
    "Payroll.punchTimeout": "Connection timeout. Please try again.",
    "Payroll.enterPinPrompt": "Enter your 4-digit PIN",
    "Payroll.invalidPin": "Invalid PIN. Please try again.",
    "Payroll.pinAlreadyUsed": "This PIN is already in use. Choose another.",
    "Payroll.pinCreated": "PIN created successfully!",
    "Payroll.pinManagement": "PIN Management",
    "Payroll.pinManagementDesc": "Manage employee punch clock PINs.",
    "Payroll.noPin": "No PIN",
    "Payroll.resetPin": "Reset PIN",
    "Payroll.resetPinConfirmTitle": "Reset this PIN",
    "Payroll.resetPinConfirmBody": "This employee will not be able to clock in or out until someone gives them a new PIN. This cannot be undone.",
    "Payroll.pinReset": "PIN has been reset",
    "Payroll.weakPin": "This PIN is too simple. Choose a stronger one.",
    "Payroll.pinNeedsFourDigits": "A PIN has four digits. Enter the four before saving.",
    "Payroll.assignPin": "Assign PIN",
    "Payroll.assignPinDesc": "Choose a four digit PIN for this employee. They will use it to punch in and out.",
    "Payroll.changePin": "Change PIN",
    "Payroll.assignPinPrompt": "Enter a 4-digit PIN for this employee.",
    "Payroll.assignPinConfirm": "Assign",
    "Payroll.pinAssigned": "PIN assigned successfully!",
    "Payroll.activeSince": "Active since",
    "Payroll.inProgress": "In progress",
    "Payroll.duration": "Duration",
    "Payroll.noHistory": "No recent punches",
    "Payroll.noPunchesInPeriod": "No punches in this period",
    "Payroll.forgottenPunchOuts": "Forgotten punch-outs",
    "Payroll.forgottenPunchFixed": "Punch-out corrected",
    "Payroll.fix": "Fix",
    "Payroll.punchOutBeforeIn": "Punch-out time must be after punch-in time.",
    "Payroll.source": "Source",
    "Payroll.manual": "Manual",
    "Payroll.forgottenPunchOut": "Employee forgot to punch out",
    "Payroll.punchSourceLockedTooltip": "Generated by the automatic punch. To correct, delete and add a new entry manually.",
    "Payroll.auditLog": "Edit History",
    "Payroll.edited": "Modification",
    "Payroll.created": "Creation",
    "Payroll.deleted": "Deletion",
    "Payroll.auditSaveSheet": "Save timesheet",
    "Payroll.auditModifyDate": "Modify",
    "Payroll.auditOpenDate": "Opened",
    "Payroll.auditDeleteDate": "Delete",
    "Payroll.filterByDate": "Filter by date",
    "Payroll.specificDay": "Specific day",
    "Payroll.filterWeek": "Week",
    "Payroll.filterMonth": "Month",
    "Payroll.customRange": "Custom range",
    "Payroll.selectRange": "Select start and end dates",
    "Payroll.selectMonday": "Select a Monday to display the week (Monday to Sunday)",
    "Payroll.selectSunday": "Select a Sunday to display the week (Sunday to Saturday)",
    "Payroll.clear": "Clear",
    "Payroll.periodLabel": "Period",
    "Payroll.affectsPayrollAndHistory": "Affects Payroll and History",
    "Payroll.employees": "Payroll",
    "Payroll.pinLocked": "PIN locked",
    "Payroll.pinLockedMinutes": "Too many failed attempts. Try again in {minutes} minutes.",
    "Payroll.pinSetLockedMinutes": "Too many PIN changes in a row. Try again in {minutes} minutes.",

    // Payroll history
    "Payroll.allEmployees": "All employees",
    "Payroll.noRunsForPeriod": "No finalized payroll for this period",
    "Payroll.view": "View",
    "Payroll.exportAllZip": "Export all (ZIP)",
    "Payroll.exportCsv": "Export CSV",
    "Payroll.csvEmployee": "Employee",
    "Payroll.csvSalaryType": "Salary Type",
    "Payroll.csvPeriodStart": "Period Start",
    "Payroll.csvPeriodEnd": "Period End",
    "Payroll.csvRegularHours": "Regular Hours",
    "Payroll.csvOvertimeHours": "Overtime Hours",
    "Payroll.csvHourlySalary": "Hourly Salary",
    "Payroll.csvFixedSalary": "Fixed Salary",
    "Payroll.csvServiceCommission": "Service Commission",
    "Payroll.csvProductCommission": "Product Commission",
    "Payroll.csvOtherCommission": "Other Commission",
    "Payroll.csvTips": "Tips",
    "Payroll.csvDeductions": "Total Deductions",
    "Payroll.csvTotal": "Grand Total",

    // Product commission tab (Bundle 6)
    "Payroll.greencircleFee": "Fee",
    "Payroll.bySection": "By section",
    "Payroll.byEmployee": "By employee",
    "Payroll.unassigned": "Unassigned",
    "Payroll.services": "services",
    "Payroll.periodStart": "Start date",
    "Payroll.periodEnd": "End date",

    // Deduction sections
    "Payroll.deductionsBasic": "Basic",
    "Payroll.deductionsBasicHint": "Applied automatically to every pay",
    "Payroll.deductionsSpecific": "Specific",
    "Payroll.deductionsSpecificHint": "Space rental, insurance, supplies, etc.",

    // Deductions
    "Payroll.deductionFrequency": "Frequency",
    "Payroll.freqPerPay": "Every pay",
    "Payroll.freqWeekly": "Weekly",
    "Payroll.freqBiweekly": "Bi-weekly",
    "Payroll.freqMonthly": "Monthly",
    "Payroll.freqOneTime": "One-time",
    "Payroll.addDeduction": "Add Deduction",
    "Payroll.editDeduction": "Edit Deduction",
    "Payroll.deductionName": "Name",
    "Payroll.deductionAmount": "Amount",
    "Payroll.deductionType": "Type",
    "Payroll.deductionRecurring": "Recurring",
    "Payroll.deductionOneTime": "One-time",
    "Payroll.deductionStartDate": "Start date",
    "Payroll.deductionEndDate": "End date (optional)",
    "Payroll.deductionNotes": "Notes (optional)",
    "Payroll.deductionSaved": "Deduction saved",
    "Payroll.deductionDeleted": "Deduction deleted",
    "Payroll.deductionDeleteTitle": "Delete this deduction?",
    "Payroll.deductionDeleteDesc": "This action cannot be undone.",
    "Payroll.totalRecurring": "Total recurring",
    "Payroll.perPeriod": "/ period",
    "Payroll.deductionSince": "Since",
    "Payroll.totalDeductionsLabel": "Total deductions",
    "Payroll.sectionDeductions": "DEDUCTIONS SECTION",
    "Payroll.dailyDeductionRow": "Daily deduction",
    "Payroll.percentDeductionRow": "% deduction on revenue",
    "Payroll.totalDeductions": "Total deductions",
    "Payroll.alreadyFinalizedOn": "Already finalized on {date}",
    "Payroll.snapshotLocked": "Locked snapshot",
    "Payroll.recalculate": "Recalculate",
    "Payroll.recalculating": "Recalculating...",
    "Payroll.recalculated": "Recalculated",
    "Payroll.finalizeTimeout": "The recalculation is taking too long. Please try again.",
    "Payroll.levelNotAssignedWarning": "Level not assigned: commissions will be 0",
    "Payroll.noCommissionRulesWarning": "No commission rule: commissions will be 0",
    "Payroll.scale.services": "Services",
    "Payroll.scale.products": "Products",
    "Payroll.scale.other": "Other sales",
    "Payroll.scale.uncategorized": "Uncategorized",
    "Payroll.scale.weekRateCommission": "Commission outside the scales",
    "Payroll.statTotalGross": "Total gross pay",
    "Payroll.statHoursWorked": "Hours worked",
    "Payroll.statActiveEmployees": "Active employees",
    "Payroll.statFinalized": "Finalized",
    "Payroll.searchEmployees": "Search employees...",
    "Payroll.forgottenPunchAlert": "{count} forgotten punch-out(s) this period.",
    "Payroll.forgottenPunchAlertAllDates": "{count} forgotten punch-out(s), all dates.",
    "Payroll.colEmployee": "Employee",
    "Payroll.colType": "Type",
    "Payroll.colHours": "Hours",
    "Payroll.colSalary": "Salary",
    "Payroll.colCommissions": "Commissions",
    "Payroll.colCommissionsProducts": "Product comm.",
    "Payroll.colCommissionsServices": "Service comm.",
    "Payroll.colCommissionsOther": "Other comm.",
    "Payroll.colDeductionsBase": "Base ded.",
    "Payroll.colDeductionsSpecific": "Specific ded.",
    "Payroll.effectiveCommissionRate": "Commission rate",
    "Payroll.colTips": "Tips",
    "Payroll.colTotalGross": "Gross total",
    "Payroll.paidVia": "Paid via {location}",
    "Payroll.paidViaHint": "Hours and sales in this location are included in this person's single pay.",
    "Payroll.showLocationBreakdown": "Show the breakdown by location",
    "Payroll.hideLocationBreakdown": "Hide the breakdown by location",
    "Payroll.otherLocation": "another location",
    "Payroll.multiLocationBlocked": "Multi-location pay: access to the payroll of all their locations is required to calculate it.",
    "Payroll.multiLocationUnavailable": "Multi-location pay: it combines all their locations and is not available here. It is calculated from the Employees tab of their main location.",
    "Payroll.multiLocationPdfDraft": "The PDF of a multi-location pay is available once the pay is finalized.",
    "Payroll.colStatus": "Status",
    "Payroll.colActions": "Actions",
    "Payroll.colPeriod": "Period",
    "Payroll.colDeductions": "Deductions",
    "Payroll.overtime": "OT",
    "Payroll.totalRow": "Total ({count} employees)",
    "Payroll.draftsReadyAlert": "{count} draft(s) ready to finalize for this period.",
    "Payroll.showPerPage": "Show",
    "Payroll.perPage": "per page",
    "Payroll.pageOf": "Page {current} of {total}",
    "Payroll.results": "{count} results",
    "Payroll.resolve": "Resolve",
    "Payroll.searchHistory": "Search...",


    // Other commission
    "Payroll.otherCommission": "Other",

    // Warnings
    "Payroll.undistributedTipsWarning": "Some tips could not be attributed (no commissionable items)",
    "Payroll.invoiceChangedWarning": "Invoices from this period have been modified since finalization. Consider recalculating.",

    // Fill from schedule
    "Payroll.fillFromScheduleResult": "{{count}} days filled from schedule",
    "Payroll.fillFromScheduleNoEmpty": "No empty days to fill",

    // Batch finalize
    "Payroll.finalizeAllTitle": "Finalize all drafts?",
    "Payroll.finalizeAllDesc": "This will finalize {{count}} draft payroll runs. This action cannot be undone.",

    // Commission rules editor (category rule, exceptions)
    "Payroll.rules.services": "Services",
    "Payroll.rules.products": "Products",
    "Payroll.rules.other": "Other sales",
    "Payroll.rules.basedOn": "Calculated on",
    "Payroll.rules.baseSale": "Sale price",
    "Payroll.rules.baseMargin": "After costs",
    "Payroll.rules.method": "Method",
    "Payroll.rules.methodRate": "Rate",
    "Payroll.rules.methodTiers": "Tiers",
    "Payroll.rules.inherit": "Inherited",
    "Payroll.rules.rateLabel": "{category} rate",
    "Payroll.rules.appliesToAll": "Applies to all {category} unless an exception below says otherwise.",
    "Payroll.rules.addServiceException": "Add an exception (section or service)",
    "Payroll.rules.addProductException": "Add an exception (supplier or product)",
    "Payroll.rules.searchTarget": "Search",
    "Payroll.rules.noTarget": "No match.",
    "Payroll.rules.inheritedFrom": "inherited from {source}: {value}",
    "Payroll.rules.customized": "customized",
    "Payroll.rules.edit": "Edit",
    "Payroll.rules.close": "Close",
    "Payroll.rules.remove": "Remove",
    "Payroll.rules.rateInvalid": "Enter a rate between 0 and 100.",
    "Payroll.rules.tierFrom": "from {amount}: {rate}",
    "Payroll.rules.tiersCumulHint": "Period total of the sales that follow this rule",
    "Payroll.rules.loadError": "The commission rules could not be loaded.",
    "Payroll.rules.retry": "Retry",
    "Payroll.rules.error.rule_forbidden": "You do not have access to this employee's pay.",
    "Payroll.rules.error.rule_category_incomplete": "Choose a basis and a method for the category.",
    "Payroll.rules.error.rule_owner_not_found": "This employee or template could not be found.",
    "Payroll.rules.error.rule_bad_target": "This exception no longer matches an item of the salon.",
    "Payroll.rules.error.rule_rate_missing": "Enter a rate between 0 and 100.",
    "Payroll.rules.error.rule_rate_invalid": "The rate must be between 0 and 100%.",
    "Payroll.rules.error.tier_not_increasing": "Each tier must start above the previous one.",
    "Payroll.rules.error.tier_empty": "Each tier needs an amount and a rate.",
    "Payroll.rules.error.tier_not_array": "Each tier needs an amount and a rate.",
    "Payroll.rules.error.tier_incomplete": "Each tier needs an amount and a rate.",
    "Payroll.rules.error.tier_too_many": "Five tiers at most.",
    "Payroll.rules.error.tier_not_number": "An amount or rate cannot be read.",
    "Payroll.rules.error.tier_amount_too_large": "The amount exceeds the maximum allowed ($99,999,999.99).",
    "Payroll.rules.error.tier_negative": "An amount cannot be negative.",
    "Payroll.rules.error.tier_rate_out_of_range": "The rate must be between 0 and 100%.",
    "Payroll.rules.error.fallback": "Save refused. Check the values.",
    "Payroll.rules.kind.section": "section",
    "Payroll.rules.kind.subsection": "subsection",
    "Payroll.rules.kind.service": "service",
    "Payroll.rules.kind.supplier": "supplier",
    "Payroll.rules.kind.uncategorized": "products without a supplier",
    "Payroll.rules.kind.product": "product",
    "Payroll.rules.group.sections": "Sections",
    "Payroll.rules.group.subsections": "Subsections",
    "Payroll.rules.group.services": "Services",
    "Payroll.rules.group.suppliers": "Suppliers",
    "Payroll.rules.group.products": "Products",
    "Payroll.rules.uncategorized": "Uncategorized",
    "Payroll.configureCompensation": "Configure pay",
    "Payroll.compensation.salary": "1. Salary",
    "Payroll.compensation.commissions": "2. Commissions",
    "Payroll.compensation.deductions": "3. Deductions",
    "Payroll.compensation.preview": "Preview",
    "Payroll.compensation.previewText": "For $3,000 of services and $600 of products over the period: {amount} in commissions, excluding costs and exceptions",
    "Payroll.compensation.previewError": "The preview could not be calculated.",
    "Payroll.compensation.commissionsAutosave": "Saved automatically when you leave each field.",
    "Payroll.compensation.save": "Save",
    "Payroll.compensation.saving": "Saving…",
    "Payroll.compensation.unsaved": "Unsaved changes",
    "Payroll.compensation.loadError": "The salary configuration could not be loaded.",
    "Payroll.template.basedOn": "Based on: {name}",
    "Payroll.template.appliedOn": "applied on {date}",
    "Payroll.template.customizedCount": "{count} customized settings",
    "Payroll.template.customizedOne": "1 customized setting",
    "Payroll.template.none": "No template applied",
    "Payroll.template.identicalToLevel": "Rules identical to the \"{template}\" template",
    "Payroll.template.applyMenu": "Apply a template",
    "Payroll.template.applying": "Applying…",
    "Payroll.template.noTemplates": "No template yet",
    "Payroll.template.levelMismatch": "{name} is at level {level}, but their pay follows the \"{applied}\" template.",
    "Payroll.template.keepApplied": "Keep \"{applied}\"",
    "Payroll.template.dontApply": "Don't apply",
    "Payroll.template.dismissFailed": "The choice could not be saved",
    "Payroll.template.applyLevel": "Apply \"{template}\"",
    "Payroll.template.confirmTitle": "Replace customized settings?",
    "Payroll.template.confirmBody": "These settings for {name} will be replaced by the template's:",
    "Payroll.template.confirm": "Replace",
    "Payroll.template.applied": "Template applied",
    "Payroll.template.appliedNoCommission": "Template applied. The current salary type does not pay commission.",
    "Payroll.template.levelSuggested": "The \"{template}\" template matches {name}'s level, {level}.",
    "Payroll.compensation.noCommissionType": "This salary type does not pay commission. Choose \"Hourly + Commission\" or \"Commission\" to set up commissions.",
    "Payroll.compensation.unsavedTitle": "Pay changes have not been saved.",
    "Payroll.compensation.unsavedOnSave": "The record will be saved without them.",
    "Payroll.compensation.unsavedOnClose": "They will be lost when the window closes.",
    "Payroll.compensation.unsavedBack": "Back to pay",
    "Payroll.compensation.unsavedLeave": "Close without saving",
    "Payroll.compensation.unsavedSaveAnyway": "Save without pay changes",
    "Payroll.template.applyFailed": "The template could not be applied",
    "Payroll.template.loadError": "The applied template could not be loaded.",
    "Payroll.templates.tab": "Pay templates",
    "Payroll.templates.new": "New template",
    "Payroll.templates.intro": "A template is copied to an employee, then adjusted.",
    "Payroll.templates.empty": "No template yet. Create the first one to apply it to your employees.",
    "Payroll.templates.loadError": "The pay templates could not be loaded.",
    "Payroll.templates.level": "level {level}",
    "Payroll.templates.free": "custom",
    "Payroll.templates.usedBy": "Used by {count} employees",
    "Payroll.templates.usedByOne": "Used by 1 employee",
    "Payroll.templates.usedByNone": "Not used by any employee",
    "Payroll.templates.actions": "Actions for {name}",
    "Payroll.templates.edit": "Edit",
    "Payroll.templates.view": "View",
    "Payroll.templates.readOnlyNote": "View only. Only an owner can edit templates.",
    "Payroll.templates.viewTitle": "Template “{name}”",
    "Payroll.templates.duplicate": "Duplicate",
    "Payroll.templates.delete": "Delete",
    "Payroll.templates.deleteTitle": "Delete “{name}”?",
    "Payroll.templates.deleteBody": "Employees using it keep their current settings.",
    "Payroll.templates.name": "Name",
    "Payroll.templates.levelField": "Suggested for employees at level",
    "Payroll.templates.levelNone": "None",
    "Payroll.templates.levelTaken": "{level} ({template})",
    "Payroll.templates.create": "Create",
    "Payroll.templates.creating": "Creating…",
    "Payroll.templates.unsavedTitle": "The template's name or level has not been saved.",
    "Payroll.templates.unsavedOnClose": "The change will be lost when the window closes.",
    "Payroll.templates.unsavedBack": "Back to the template",
    "Payroll.templates.rulesAfterCreate": "Commissions are set once the template is created.",
    "Payroll.templates.editorHint": "Commissions below are saved as you change them. The name and level are saved with the button.",
    "Payroll.templates.nameRequired": "Enter a name.",
    "Payroll.templates.nameTaken": "Another template already has this name.",
    "Payroll.templates.levelTakenError": "This level already has a template.",
    "Payroll.templates.saved": "Template saved",
    "Payroll.templates.created": "Template created",
    "Payroll.templates.deleted": "Template deleted",
    "Payroll.templates.duplicated": "Template duplicated",
    "Payroll.templates.saveFailed": "The template could not be saved",
    "Payroll.templates.deleteFailed": "The template could not be deleted",
    "Payroll.templates.duplicateFailed": "The template could not be duplicated",
    "Payroll.templates.incomplete": "The template “{name}” was left incomplete. Delete it, then try again.",
    "Payroll.templates.copyName": "{name} (copy)",
    "Payroll.templates.changed": "{name} has changed.",
    "Payroll.templates.outdated": "{count} employees still have the previous version.",
    "Payroll.templates.outdatedOne": "1 employee still has the previous version.",
    "Payroll.templates.reapply": "Reapply…",
    "Payroll.templates.reapplyTitle": "Reapply “{name}”",
    "Payroll.templates.reapplySame": "same as the previous version",
    "Payroll.templates.reapplyReplaces": "Reapplying would replace: {labels}",
    "Payroll.templates.reapplyFuture": "Applies to upcoming pay runs. Finalized pay runs do not change.",
    "Payroll.templates.reapplyCount": "Reapply to {count} employees",
    "Payroll.templates.reapplyCountOne": "Reapply to 1 employee",
    "Payroll.templates.reapplyZero": "Reapply",
    "Payroll.templates.reapplyNone": "Select at least one employee.",
    "Payroll.templates.reapplyLoadError": "The employees' settings could not be loaded.",
    "Payroll.templates.reapplied": "Template reapplied",
    "Payroll.templates.later": "Later",
    "Payroll.templates.summaryService": "Services",
    "Payroll.templates.summaryProduct": "Products",
    "Payroll.templates.summaryOther": "Other sales",
    "Payroll.templates.summaryMargin": "after costs",
    "Payroll.templates.summarySale": "sale price",
    "Payroll.templates.summaryTiers": "tiers {min} to {max}",
    "Payroll.templates.summaryTiersOne": "tiers {rate}",
    "Payroll.templates.summaryExceptions": ", {count} exceptions",
    "Payroll.templates.summaryExceptionsOne": ", 1 exception",
    "Payroll.templates.summaryNone": "No commission set",
  },
  fr: {

    // Payroll toast messages (errorToast / successToast wrapper)
    "Payroll.toast.savePunchFailed": "Impossible d'enregistrer le pointage",
    "Payroll.toast.savePinFailed": "Impossible d'enregistrer le NIP",
    "Payroll.toast.pinCreated": "NIP créé",
    "Payroll.toast.fixTimeInvalid": "L'heure de sortie doit être après l'heure d'entrée.",
    "Payroll.toast.scheduleApplied": "Horaire appliqué",
    "Payroll.toast.auditWarning": "Feuille de temps enregistrée mais le journal d'audit a échoué",
    "Payroll.toast.auditWarningDesc": "Certaines entrées du journal d'audit n'ont pas pu être enregistrées. Contactez le support si le problème persiste.",
    "Payroll.toast.recalculated": "Recalculé",
    "Payroll.toast.finalized": "Finalisé",

    // Additional Payroll toast messages
    "Payroll.toast.deleteDeductionFailed": "Impossible de supprimer la déduction",
    "Payroll.toast.punchInFailed": "Impossible de poinçonner l'arrivée",
    "Payroll.toast.punchOutFailed": "Impossible de poinçonner le départ",
    "Payroll.toast.resetPinFailed": "Impossible de réinitialiser le NIP",
    "Payroll.toast.saveDeductionFailed": "Impossible d'enregistrer la déduction",

    // D8 : panne technique de l'export (500), distincte d'un refus de droits (403).
    "Payroll.exportTemporaryError": "Erreur temporaire, veuillez réessayer.",
    "Payroll.presenceMapError": "Impossible de vérifier quelles paies réunissent plusieurs succursales. Leur détail reste fermé tant que cette vérification n'a pas réussi.",
    "Payroll.bulkNothingToPrint": "Rien à imprimer pour cette période : les paies des personnes de plusieurs succursales s'impriment une fois finalisées.",

    // Payroll Module
    "Payroll.title": "Paie",
    "Payroll.subtitle": "Gestion de la paie des employés",
    "Payroll.subtitleOwn": "Votre paie",
    "Payroll.ownTab": "Ma paie",
    "Payroll.noOwnFiche": "Aucune fiche d'employé n'est liée à votre compte dans ce salon.",
    "Payroll.noAccessTitle": "Accès refusé",
    "Payroll.noAccessDescription": "Vous n'avez pas la permission de voir la paie. Contactez le propriétaire du salon pour demander l'accès.",
    "Payroll.noEmployees": "Aucun employé trouvé. Ajoutez des employés d'abord.",
    "Payroll.notConfigured": "Non configuré",
    "Payroll.timesheet": "Feuille de temps",
    "Payroll.auditWarning": "Feuille de temps enregistrée mais le journal d'audit a échoué",
    "Payroll.auditWarningDesc": "Certaines entrées d'audit n'ont pas pu être enregistrées. Contactez le support si le problème persiste.",
    "Payroll.report": "Rapport",
    "Payroll.salaryType": "Type de salaire",
    "Payroll.hourly": "Horaire",
    "Payroll.commission": "Commission",
    "Payroll.hourlyCommission": "Horaire + Commission",
    "Payroll.fixed": "Fixe",
    "Payroll.hourlyRate": "Taux horaire",
    "Payroll.fixedSalary": "Salaire fixe",
    "Payroll.fixedSalaryUnit": "Payé par",
    "Payroll.fixedUnitPerPeriod": "Période de paie",
    "Payroll.fixedUnitWeekly": "Semaine",
    "Payroll.fixedUnitBiweekly": "2 semaines",
    "Payroll.fixedUnitMonthly": "Mois",
    "Payroll.fixedUnitYearly": "Année",
    "Payroll.regularHoursPerWeek": "Heures régulières/semaine",
    "Payroll.overtimeMultiplier": "Multiplicateur heures supp.",
    "Payroll.deductions": "Déductions",
    "Payroll.dailyDeduction": "Déduction quotidienne",
    "Payroll.payDeductionPercent": "% par paie",

    // Commissions par paliers (échelle configurée par le propriétaire, par employé et par catégorie)
    "Payroll.commissionCategory.service": "Services",
    "Payroll.commissionCategory.product": "Produits",
    "Payroll.commissionCategory.other": "Autres",
    "Payroll.commissionThreshold": "Seuil avant commission",
    "Payroll.commissionTierN": "Palier {n}",
    "Payroll.commissionTierUpTo": "Jusqu'à",
    "Payroll.commissionTierBeyond": "au-delà",
    "Payroll.commissionTierAdd": "Ajouter un palier",
    "Payroll.commissionTierRemove": "Retirer ce palier",
    "Payroll.commissionTierRate": "Taux",
    "Payroll.commissionPreviewTotal": "Commission de la période",
    "Payroll.tipsThroughPayroll": "Verser les pourboires par la paie",
    "Payroll.tipsThroughPayrollOn": "Les pourboires apparaissent sur le talon et entrent dans le total à payer.",
    "Payroll.tipsThroughPayrollOff": "Les pourboires restent hors paie. Le talon les affiche pour information, hors du total.",
    "Payroll.commissionTierUnreadable": "Un montant est illisible : cette échelle n'est donc pas enregistrée. Saisissez des chiffres seulement, avec au plus deux décimales, par exemple 1000 ou 1000,50.",
    "Payroll.reportContextError": "Les données de paie de cet employé n'ont pas pu être chargées : ce rapport ne peut donc pas être finalisé. Fermez-le puis rouvrez-le pour réessayer.",
    "Payroll.liveDataErrorTitle": "Impossible de calculer la paie",
    "Payroll.liveDataErrorDescription": "Une partie des données n'a pas pu être chargée. Aucun montant n'est affiché pour éviter un total faux. Veuillez réessayer.",

    // Détail de la commission par paliers sur le talon de paie
    "Payroll.tierBreakdownTitle": "Commission par paliers",
    "Payroll.tierBand": "Tranche du cumul",
    "Payroll.tierBelowThreshold": "Sous le seuil",
    "Payroll.tierAdjustedAmount": "Montant ajusté",
    "Payroll.tierNonCommissionable": "Part non commissionnable",
    "Payroll.tierCalculatedOnPeriod": "Paliers calculés sur le cumul de la période, pas par semaine",
    "Payroll.tipsOutsidePayroll": "Pourboires versés hors paie",
    "Payroll.tipsNotInTotal": "hors de ce total",

    "Payroll.productCommission": "Commission produit",
    "Payroll.serviceCommission": "Commission service",
    "Payroll.configSaved": "Configuration enregistrée",
    "Payroll.configError": "Erreur lors de l'enregistrement",
    "Payroll.period": "Période",
    "Payroll.date": "Date",
    "Payroll.startTime": "Entrée",
    "Payroll.endTime": "Sortie",
    "Payroll.lunch": "Dîner",
    // `break_minutes`, i.e. unpaid break minutes deducted from the shift. NOT
    // "Congé", which reads as vacation/time off and had owners misreading the column.
    "Payroll.break": "Pauses",
    "Payroll.total": "Total",
    "Payroll.totalHours": "Total des heures",
    "Payroll.week": "Semaine",
    "Payroll.timesheetSaved": "Feuille de temps enregistrée",
    "Payroll.timesheetError": "Erreur lors de l'enregistrement",
    "Payroll.payrollReport": "Rapport de paie",
    "Payroll.fixedSalarySection": "SECTION SALAIRE FIXE",
    "Payroll.fixedSalaryForPeriod": "Salaire fixe pour la période",
    "Payroll.hourlyRevenueSection": "SECTION DES REVENUS HORAIRES",
    "Payroll.timesheetSection": "FEUILLE DE TEMPS",
    "Payroll.regularHours": "Heures régulières",
    "Payroll.overtimeHours": "Heures supplémentaires",
    "Payroll.weekTotal": "Total semaine",
    "Payroll.totalHoursAllWeeks": "Total toutes semaines",
    "Payroll.tipsSection": "SECTION DES POURBOIRES",
    "Payroll.tips": "Pourboires",
    "Payroll.commissionSection": "SECTION DES COMMISSIONS",
    "Payroll.revenue": "Revenu",
    "Payroll.cost": "Coûtant",
    "Payroll.internalProducts": "Produits internes",
    "Payroll.totalHourlySalary": "Salaire horaire",
    "Payroll.grandTotal": "GRAND TOTAL",
    "Payroll.generatedOn": "Généré le",
    "Payroll.downloadPDF": "Imprimer / PDF",
    "Payroll.history": "Historique",
    "Payroll.finalize": "Finaliser",
    "Payroll.finalizeAll": "Finaliser tout",
    "Payroll.finalizeConfirm": "Finaliser la paie de",
    "Payroll.finalizeWarning": "Les feuilles de temps de cette période seront verrouillées en lecture seule.",
    "Payroll.finalized": "Finalisé",
    "Payroll.finalizedAt": "Finalisé le",
    "Payroll.finalizedBy": "par",
    "Payroll.draft": "Brouillon",
    "Payroll.periodLocked": "Période finalisée : lecture seule",
    "Payroll.fillFromSchedule": "Remplir depuis l'horaire",
    "Payroll.fillFromScheduleDone": "Horaire appliqué",
    "Payroll.daysFilled": "jours remplis depuis l'horaire",
    "Payroll.noDaysToFill": "Aucun jour vide ne correspond à l'horaire",
    "Payroll.importScheduleForPeriod": "Importer les heures planifiées",
    "Payroll.importScheduleDialogTitle": "Importer les heures depuis l'horaire",
    "Payroll.importScheduleDialogDescription": "Cette action importe les heures planifiées de toute l'équipe pour la période de paie sélectionnée. Vérifiez les détails ci-dessous avant de confirmer.",
    "Payroll.importScheduleConfirm": "Confirmer l'import",
    // Deux comptes dans une seule phrase : `pluralize` n'en accorde qu'un.
    // La tournure vaut donc au singulier comme au pluriel.
    "Payroll.importScheduleWillCreate": "Journées à créer : {days}. Employés concernés : {employees}.",
    "Payroll.importScheduleSkippedExistingOne": "1 journée porte déjà une ligne et ne sera pas touchée",
    "Payroll.importScheduleSkippedExisting": "{count} journées portent déjà une ligne et ne seront pas touchées",
    "Payroll.importScheduleSkippedLockedOne": "1 journée appartient à une paie finalisée et ne peut pas changer",
    "Payroll.importScheduleSkippedLocked": "{count} journées appartiennent à une paie finalisée et ne peuvent pas changer",
    "Payroll.importScheduleLunchWarning": "Les heures importées viennent de votre horaire. Si votre pause repas n'est pas bloquée au calendrier, elle ne sera pas déduite : vérifiez les journées concernées avant de finaliser la paie.",
    "Payroll.importScheduleNothing": "Rien à importer : chaque journée planifiée porte déjà une ligne.",
    // Bilan RÉEL de l'import, compté sur les lignes rendues par la base, jamais
    // sur le plan : une ligne peut naître entre la lecture et l'écriture.
    "Payroll.importScheduleDoneOne": "1 journée a été importée.",
    "Payroll.importScheduleDone": "{count} journées ont été importées.",
    "Payroll.importScheduleDoneNone": "Aucune journée importée : elles portaient toutes déjà une ligne.",
    "Payroll.sourceSchedule": "Depuis l'horaire",
    "Payroll.exportAll": "Exporter tout (ZIP)",
    "Payroll.downloadPdf": "Télécharger PDF",
    "Payroll.filterEmployee": "Employé",
    "Payroll.filterYear": "Année",
    "Payroll.noRunsFound": "Aucun enregistrement de paie trouvé pour cette période.",
    "Payroll.finalizeAllConfirm": "Finaliser la paie de tous les employés pour cette période ?",
    "Payroll.generateReport": "Générer le rapport",
    "Payroll.punchInOut": "Pointer entrée/sortie",
    "Payroll.punchInOutDesc": "Entrez votre NIP personnel pour pointer votre arrivée ou départ.",
    "Payroll.punchClock": "Horloge de pointage",
    "Payroll.punchClockDesc": "Saisissez votre NIP à quatre chiffres pour enregistrer votre entrée ou votre sortie.",
    "Payroll.punchIn": "Entrée",
    "Payroll.punchOut": "Sortie",
    "Payroll.punchTimeout": "Délai de connexion dépassé. Veuillez réessayer.",
    "Payroll.enterPinPrompt": "Entrez votre NIP à 4 chiffres",
    "Payroll.invalidPin": "NIP invalide. Veuillez réessayer.",
    "Payroll.pinAlreadyUsed": "Ce NIP est déjà utilisé. Choisissez-en un autre.",
    "Payroll.pinCreated": "NIP créé avec succès !",
    "Payroll.pinManagement": "Gestion des NIP",
    "Payroll.pinManagementDesc": "Gérer les NIP de pointage des employés.",
    "Payroll.noPin": "Aucun NIP",
    "Payroll.resetPin": "Réinitialiser le NIP",
    "Payroll.resetPinConfirmTitle": "Réinitialiser ce NIP",
    "Payroll.resetPinConfirmBody": "Cet employé ne pourra plus pointer tant que personne ne lui aura posé un nouveau NIP. Cette action est irréversible.",
    "Payroll.pinReset": "Le NIP a été réinitialisé",
    "Payroll.weakPin": "Ce NIP est trop simple. Choisissez un NIP plus sécuritaire.",
    "Payroll.pinNeedsFourDigits": "Un NIP a quatre chiffres. Saisissez les quatre avant d'enregistrer.",
    "Payroll.assignPin": "Attribuer un NIP",
    "Payroll.assignPinDesc": "Choisissez un NIP à quatre chiffres pour cet employé. Il lui servira à pointer.",
    "Payroll.changePin": "Changer le NIP",
    "Payroll.assignPinPrompt": "Entrez un NIP à 4 chiffres pour cet employé.",
    "Payroll.assignPinConfirm": "Attribuer",
    "Payroll.pinAssigned": "NIP attribué avec succès !",
    "Payroll.activeSince": "Actif depuis",
    "Payroll.inProgress": "En cours",
    "Payroll.duration": "Durée",
    "Payroll.noHistory": "Aucun pointage récent",
    "Payroll.noPunchesInPeriod": "Aucun pointage pour cette période",
    "Payroll.forgottenPunchOuts": "Pointages de sortie oubliés",
    "Payroll.forgottenPunchFixed": "Pointage de sortie corrigé",
    "Payroll.fix": "Corriger",
    "Payroll.punchOutBeforeIn": "L'heure de sortie doit être après l'heure d'entrée.",
    "Payroll.source": "Source",
    "Payroll.manual": "Manuel",
    "Payroll.forgottenPunchOut": "L'employé a oublié de pointer sa sortie",
    "Payroll.punchSourceLockedTooltip": "Généré par le pointage automatique. Pour corriger, supprimez et ajoutez une nouvelle entrée manuellement.",
    "Payroll.auditLog": "Historique des modifications",
    "Payroll.edited": "Modification",
    "Payroll.created": "Création",
    "Payroll.deleted": "Suppression",
    "Payroll.auditSaveSheet": "Enregistrer la feuille",
    "Payroll.auditModifyDate": "Modifier le",
    "Payroll.auditOpenDate": "Ouvert le",
    "Payroll.auditDeleteDate": "Supprimer le",
    "Payroll.filterByDate": "Filtrer par date",
    "Payroll.specificDay": "Jour spécifique",
    "Payroll.filterWeek": "Semaine",
    "Payroll.filterMonth": "Mois",
    "Payroll.customRange": "Intervalle personnalisé",
    "Payroll.selectRange": "Sélectionnez les dates de début et de fin",
    "Payroll.selectMonday": "Sélectionnez un lundi pour afficher la semaine (lundi au dimanche)",
    "Payroll.selectSunday": "Sélectionnez un dimanche pour afficher la semaine (dimanche au samedi)",
    "Payroll.clear": "Effacer",
    "Payroll.periodLabel": "Période",
    "Payroll.affectsPayrollAndHistory": "Affecte Paie et Historique",
    "Payroll.employees": "Paie",
    "Payroll.pinLocked": "NIP verrouillé",
    "Payroll.pinLockedMinutes": "Trop de tentatives échouées. Réessayez dans {minutes} minutes.",
    "Payroll.pinSetLockedMinutes": "Trop de changements de NIP coup sur coup. Réessayez dans {minutes} minutes.",

    // Historique de paie
    "Payroll.allEmployees": "Tous les employés",
    "Payroll.noRunsForPeriod": "Aucune paie finalisée pour cette période",
    "Payroll.view": "Voir",
    "Payroll.exportAllZip": "Exporter tout (ZIP)",
    "Payroll.exportCsv": "Exporter CSV",
    "Payroll.csvEmployee": "Employé",
    "Payroll.csvSalaryType": "Type de salaire",
    "Payroll.csvPeriodStart": "Début période",
    "Payroll.csvPeriodEnd": "Fin de période",
    "Payroll.csvRegularHours": "Heures régulières",
    "Payroll.csvOvertimeHours": "Heures supplémentaires",
    "Payroll.csvHourlySalary": "Salaire horaire",
    "Payroll.csvFixedSalary": "Salaire fixe",
    "Payroll.csvServiceCommission": "Commission services",
    "Payroll.csvProductCommission": "Commission produits",
    "Payroll.csvOtherCommission": "Commission autres",
    "Payroll.csvTips": "Pourboires",
    "Payroll.csvDeductions": "Total déductions",
    "Payroll.csvTotal": "Total brut",

    // Onglet commission produit (Bundle 6)
    "Payroll.greencircleFee": "Frais",
    "Payroll.bySection": "Par section",
    "Payroll.byEmployee": "Par employé",
    "Payroll.unassigned": "Non assigné",
    "Payroll.services": "services",
    "Payroll.periodStart": "Date de début",
    "Payroll.periodEnd": "Date de fin",

    // Sections de déductions
    "Payroll.deductionsBasic": "De base",
    "Payroll.deductionsBasicHint": "Appliquées automatiquement à chaque paie",
    "Payroll.deductionsSpecific": "Spécifique",
    "Payroll.deductionsSpecificHint": "Location d'espace, assurances, matériel, etc.",

    // Déductions
    "Payroll.deductionFrequency": "Fréquence",
    "Payroll.freqPerPay": "À chaque paie",
    "Payroll.freqWeekly": "Hebdomadaire",
    "Payroll.freqBiweekly": "Bi-hebdomadaire",
    "Payroll.freqMonthly": "Mensuel",
    "Payroll.freqOneTime": "Ponctuel",
    "Payroll.addDeduction": "Ajouter une déduction",
    "Payroll.editDeduction": "Modifier la déduction",
    "Payroll.deductionName": "Nom",
    "Payroll.deductionAmount": "Montant",
    "Payroll.deductionType": "Type",
    "Payroll.deductionRecurring": "Récurrent",
    "Payroll.deductionOneTime": "Ponctuel",
    "Payroll.deductionStartDate": "Date de début",
    "Payroll.deductionEndDate": "Date de fin (optionnel)",
    "Payroll.deductionNotes": "Notes (optionnel)",
    "Payroll.deductionSaved": "Déduction enregistrée",
    "Payroll.deductionDeleted": "Déduction supprimée",
    "Payroll.deductionDeleteTitle": "Supprimer cette déduction ?",
    "Payroll.deductionDeleteDesc": "Cette action est irréversible.",
    "Payroll.totalRecurring": "Total récurrent",
    "Payroll.perPeriod": "/ période",
    "Payroll.deductionSince": "Depuis",
    "Payroll.totalDeductionsLabel": "Total déductions",
    "Payroll.sectionDeductions": "SECTION DES DÉDUCTIONS",
    "Payroll.dailyDeductionRow": "Déduction journalière",
    "Payroll.percentDeductionRow": "Déduction % sur revenu",
    "Payroll.totalDeductions": "Total déductions",
    "Payroll.alreadyFinalizedOn": "Déjà finalisé le {date}",
    "Payroll.snapshotLocked": "Snapshot verrouillé",
    "Payroll.recalculate": "Recalculer",
    "Payroll.recalculating": "Recalcul en cours...",
    "Payroll.recalculated": "Recalculé",
    "Payroll.finalizeTimeout": "Le recalcul prend trop de temps. Veuillez réessayer.",
    "Payroll.levelNotAssignedWarning": "Niveau non assigné : commissions à 0",
    "Payroll.noCommissionRulesWarning": "Aucune règle de commission : commissions à 0",
    "Payroll.scale.services": "Services",
    "Payroll.scale.products": "Produits",
    "Payroll.scale.other": "Autres ventes",
    "Payroll.scale.uncategorized": "Non catégorisé",
    "Payroll.scale.weekRateCommission": "Commission hors paliers",
    "Payroll.statTotalGross": "Total paie brute",
    "Payroll.statHoursWorked": "Heures travaillées",
    "Payroll.statActiveEmployees": "Employés actifs",
    "Payroll.statFinalized": "Paies finalisées",
    "Payroll.searchEmployees": "Rechercher un employé...",
    "Payroll.forgottenPunchAlert": "{count} sortie(s) de pointage oubliée(s) cette période.",
    "Payroll.forgottenPunchAlertAllDates": "{count} sortie(s) de pointage oubliée(s), toutes dates confondues.",
    "Payroll.colEmployee": "Employé",
    "Payroll.colType": "Type",
    "Payroll.colHours": "Heures",
    "Payroll.colSalary": "Salaire",
    "Payroll.colCommissions": "Commissions",
    "Payroll.colCommissionsProducts": "Comm. produits",
    "Payroll.colCommissionsServices": "Comm. services",
    "Payroll.colCommissionsOther": "Comm. autres",
    "Payroll.colDeductionsBase": "Déd. base",
    "Payroll.colDeductionsSpecific": "Déd. spéc.",
    "Payroll.effectiveCommissionRate": "Taux moyen",
    "Payroll.colTips": "Pourboires",
    "Payroll.colTotalGross": "Total brut",
    "Payroll.paidVia": "Payé via {location}",
    "Payroll.paidViaHint": "Les heures et les ventes de cette succursale sont comprises dans la paie unique de cette personne.",
    "Payroll.showLocationBreakdown": "Voir le détail par succursale",
    "Payroll.hideLocationBreakdown": "Masquer le détail par succursale",
    "Payroll.otherLocation": "une autre succursale",
    "Payroll.multiLocationBlocked": "Paie multi-succursales : l'accès à la paie de toutes ses succursales est requis pour la calculer.",
    "Payroll.multiLocationUnavailable": "Paie multi-succursales : elle réunit toutes ses succursales et n'est pas disponible ici. Elle se calcule depuis l'onglet Employés de sa succursale principale.",
    "Payroll.multiLocationPdfDraft": "Le PDF d'une paie multi-succursales est disponible une fois la paie finalisée.",
    "Payroll.colStatus": "Statut",
    "Payroll.colActions": "Actions",
    "Payroll.colPeriod": "Période",
    "Payroll.colDeductions": "Déductions",
    "Payroll.overtime": "Supp.",
    "Payroll.totalRow": "Total ({count} employés)",
    "Payroll.draftsReadyAlert": "{count} brouillon(s) prêt(s) à finaliser pour cette période.",
    "Payroll.showPerPage": "Afficher",
    "Payroll.perPage": "par page",
    "Payroll.pageOf": "Page {current} sur {total}",
    "Payroll.results": "{count} résultats",
    "Payroll.resolve": "Résoudre",
    "Payroll.searchHistory": "Rechercher...",

    // Seuils de commission

    // Commission autres
    "Payroll.otherCommission": "Autres",

    // Avertissements
    "Payroll.undistributedTipsWarning": "Des pourboires n'ont pas pu être attribués (aucun item commissionnable)",
    "Payroll.invoiceChangedWarning": "Des factures de cette période ont été modifiées depuis la finalisation. Envisagez de recalculer.",

    // Remplir depuis l'horaire
    "Payroll.fillFromScheduleResult": "{{count}} jours remplis depuis l'horaire",
    "Payroll.fillFromScheduleNoEmpty": "Aucun jour vide à remplir",

    // Finalisation en lot
    "Payroll.finalizeAllTitle": "Finaliser tous les brouillons?",
    "Payroll.finalizeAllDesc": "Ceci finalisera {{count}} brouillons de paie. Cette action est irréversible.",

    // Éditeur des règles de commission (règle de catégorie, exceptions)
    "Payroll.rules.services": "Services",
    "Payroll.rules.products": "Produits",
    "Payroll.rules.other": "Autres ventes",
    "Payroll.rules.basedOn": "Calculée sur",
    "Payroll.rules.baseSale": "Prix vendu",
    "Payroll.rules.baseMargin": "Après coûts",
    "Payroll.rules.method": "Méthode",
    "Payroll.rules.methodRate": "Taux",
    "Payroll.rules.methodTiers": "Paliers",
    "Payroll.rules.inherit": "Hérité",
    "Payroll.rules.rateLabel": "Taux des {category}",
    "Payroll.rules.appliesToAll": "S'applique à tous les {category}, sauf les exceptions ci-dessous.",
    "Payroll.rules.addServiceException": "Ajouter une exception (section ou service)",
    "Payroll.rules.addProductException": "Ajouter une exception (fournisseur ou produit)",
    "Payroll.rules.searchTarget": "Rechercher",
    "Payroll.rules.noTarget": "Aucun résultat.",
    "Payroll.rules.inheritedFrom": "hérité de {source} : {value}",
    "Payroll.rules.customized": "personnalisé",
    "Payroll.rules.edit": "Modifier",
    "Payroll.rules.close": "Fermer",
    "Payroll.rules.remove": "Retirer",
    "Payroll.rules.rateInvalid": "Entrez un taux entre 0 et 100.",
    "Payroll.rules.tierFrom": "dès {amount} : {rate}",
    "Payroll.rules.tiersCumulHint": "Cumul des ventes de la période qui suivent cette règle",
    "Payroll.rules.loadError": "Les règles de commission n'ont pas pu être chargées.",
    "Payroll.rules.retry": "Réessayer",
    "Payroll.rules.error.rule_forbidden": "Vous n'avez pas accès à la rémunération de cet employé.",
    "Payroll.rules.error.rule_category_incomplete": "Choisissez une base et une méthode pour la catégorie.",
    "Payroll.rules.error.rule_owner_not_found": "Cet employé ou ce modèle est introuvable.",
    "Payroll.rules.error.rule_bad_target": "Cette exception ne correspond plus à un élément du salon.",
    "Payroll.rules.error.rule_rate_missing": "Entrez un taux entre 0 et 100.",
    "Payroll.rules.error.rule_rate_invalid": "Le taux doit être entre 0 et 100 %.",
    "Payroll.rules.error.tier_not_increasing": "Chaque palier doit commencer au-dessus du précédent.",
    "Payroll.rules.error.tier_empty": "Chaque palier doit avoir un montant et un taux.",
    "Payroll.rules.error.tier_not_array": "Chaque palier doit avoir un montant et un taux.",
    "Payroll.rules.error.tier_incomplete": "Chaque palier doit avoir un montant et un taux.",
    "Payroll.rules.error.tier_too_many": "Cinq paliers au maximum.",
    "Payroll.rules.error.tier_not_number": "Un montant ou un taux est illisible.",
    "Payroll.rules.error.tier_amount_too_large": "Le montant dépasse le maximum permis (99 999 999,99 $).",
    "Payroll.rules.error.tier_negative": "Un montant ne peut pas être négatif.",
    "Payroll.rules.error.tier_rate_out_of_range": "Le taux doit être entre 0 et 100 %.",
    "Payroll.rules.error.fallback": "Enregistrement refusé. Vérifiez les valeurs.",
    "Payroll.rules.kind.section": "section",
    "Payroll.rules.kind.subsection": "sous-section",
    "Payroll.rules.kind.service": "service",
    "Payroll.rules.kind.supplier": "fournisseur",
    "Payroll.rules.kind.uncategorized": "produits sans fournisseur",
    "Payroll.rules.kind.product": "produit",
    "Payroll.rules.group.sections": "Sections",
    "Payroll.rules.group.subsections": "Sous-sections",
    "Payroll.rules.group.services": "Services",
    "Payroll.rules.group.suppliers": "Fournisseurs",
    "Payroll.rules.group.products": "Produits",
    "Payroll.rules.uncategorized": "Non catégorisé",
    "Payroll.configureCompensation": "Configurer la rémunération",
    "Payroll.compensation.salary": "1. Salaire",
    "Payroll.compensation.commissions": "2. Commissions",
    "Payroll.compensation.deductions": "3. Déductions",
    "Payroll.compensation.preview": "Aperçu",
    "Payroll.compensation.previewText": "Pour 3 000 $ de services et 600 $ de produits sur la période : {amount} de commissions, hors coûts de revient et exceptions",
    "Payroll.compensation.previewError": "L'aperçu n'a pas pu être calculé.",
    "Payroll.compensation.commissionsAutosave": "Enregistré automatiquement à la sortie de chaque champ.",
    "Payroll.compensation.save": "Enregistrer",
    "Payroll.compensation.saving": "Enregistrement…",
    "Payroll.compensation.unsaved": "Modifications non enregistrées",
    "Payroll.compensation.loadError": "La configuration salariale n'a pas pu être chargée.",
    "Payroll.template.basedOn": "Basé sur : {name}",
    "Payroll.template.appliedOn": "appliqué le {date}",
    "Payroll.template.customizedCount": "{count} réglages personnalisés",
    "Payroll.template.customizedOne": "1 réglage personnalisé",
    "Payroll.template.none": "Aucun modèle appliqué",
    "Payroll.template.identicalToLevel": "Règles identiques au modèle « {template} »",
    "Payroll.template.applyMenu": "Appliquer un modèle",
    "Payroll.template.applying": "Application en cours…",
    "Payroll.template.noTemplates": "Aucun modèle pour l'instant",
    "Payroll.template.levelMismatch": "{name} est au niveau {level}, mais sa rémunération suit le modèle « {applied} ».",
    "Payroll.template.keepApplied": "Garder « {applied} »",
    "Payroll.template.dontApply": "Ne pas appliquer",
    "Payroll.template.dismissFailed": "Le choix n'a pas pu être enregistré",
    "Payroll.template.applyLevel": "Appliquer « {template} »",
    "Payroll.template.confirmTitle": "Remplacer les réglages personnalisés ?",
    "Payroll.template.confirmBody": "Ces réglages de {name} seront remplacés par ceux du modèle :",
    "Payroll.template.confirm": "Remplacer",
    "Payroll.template.applied": "Modèle appliqué",
    "Payroll.template.appliedNoCommission": "Modèle appliqué. Le type de salaire actuel ne verse pas de commission.",
    "Payroll.template.levelSuggested": "Le modèle « {template} » correspond au niveau {level} de {name}.",
    "Payroll.compensation.noCommissionType": "Ce type de salaire ne verse pas de commission. Choisissez « Horaire + Commission » ou « Commission » pour régler les commissions.",
    "Payroll.compensation.unsavedTitle": "Des modifications de rémunération ne sont pas enregistrées.",
    "Payroll.compensation.unsavedOnSave": "La fiche sera enregistrée sans elles.",
    "Payroll.compensation.unsavedOnClose": "Elles seront perdues à la fermeture.",
    "Payroll.compensation.unsavedBack": "Revenir à la rémunération",
    "Payroll.compensation.unsavedLeave": "Fermer sans enregistrer",
    "Payroll.compensation.unsavedSaveAnyway": "Enregistrer sans la rémunération",
    "Payroll.template.applyFailed": "Le modèle n'a pas pu être appliqué",
    "Payroll.template.loadError": "Le modèle appliqué n'a pas pu être chargé.",
    "Payroll.templates.tab": "Modèles de rémunération",
    "Payroll.templates.new": "Nouveau modèle",
    "Payroll.templates.intro": "Un modèle se recopie chez un employé, qu'on ajuste ensuite.",
    "Payroll.templates.empty": "Aucun modèle pour l'instant. Créez le premier pour l'appliquer à vos employés.",
    "Payroll.templates.loadError": "Les modèles de rémunération n'ont pas pu être chargés.",
    "Payroll.templates.level": "niveau {level}",
    "Payroll.templates.free": "libre",
    "Payroll.templates.usedBy": "Utilisé par {count} employés",
    "Payroll.templates.usedByOne": "Utilisé par 1 employé",
    "Payroll.templates.usedByNone": "Aucun employé ne l'utilise",
    "Payroll.templates.actions": "Actions pour {name}",
    "Payroll.templates.edit": "Modifier",
    "Payroll.templates.view": "Voir",
    "Payroll.templates.readOnlyNote": "Consultation seulement. Seul un propriétaire peut modifier les modèles.",
    "Payroll.templates.viewTitle": "Modèle « {name} »",
    "Payroll.templates.duplicate": "Dupliquer",
    "Payroll.templates.delete": "Supprimer",
    "Payroll.templates.deleteTitle": "Supprimer « {name} » ?",
    "Payroll.templates.deleteBody": "Les employés qui l'utilisent gardent leurs réglages actuels.",
    "Payroll.templates.name": "Nom",
    "Payroll.templates.levelField": "Proposé aux employés de niveau",
    "Payroll.templates.levelNone": "Aucun",
    "Payroll.templates.levelTaken": "{level} ({template})",
    "Payroll.templates.create": "Créer",
    "Payroll.templates.creating": "Création en cours…",
    "Payroll.templates.unsavedTitle": "Le nom ou le niveau du modèle n'est pas enregistré.",
    "Payroll.templates.unsavedOnClose": "La modification sera perdue à la fermeture.",
    "Payroll.templates.unsavedBack": "Revenir au modèle",
    "Payroll.templates.rulesAfterCreate": "Les commissions se règlent une fois le modèle créé.",
    "Payroll.templates.editorHint": "Les commissions ci-dessous s'enregistrent à mesure que vous les modifiez. Le nom et le niveau s'enregistrent avec le bouton.",
    "Payroll.templates.nameRequired": "Entrez un nom.",
    "Payroll.templates.nameTaken": "Un autre modèle porte déjà ce nom.",
    "Payroll.templates.levelTakenError": "Ce niveau a déjà un modèle.",
    "Payroll.templates.saved": "Modèle enregistré",
    "Payroll.templates.created": "Modèle créé",
    "Payroll.templates.deleted": "Modèle supprimé",
    "Payroll.templates.duplicated": "Modèle dupliqué",
    "Payroll.templates.saveFailed": "Le modèle n'a pas pu être enregistré",
    "Payroll.templates.deleteFailed": "Le modèle n'a pas pu être supprimé",
    "Payroll.templates.duplicateFailed": "Le modèle n'a pas pu être dupliqué",
    "Payroll.templates.incomplete": "Le modèle « {name} » est resté incomplet. Supprimez-le, puis recommencez.",
    "Payroll.templates.copyName": "{name} (copie)",
    "Payroll.templates.changed": "{name} a changé.",
    "Payroll.templates.outdated": "{count} employés ont encore l'ancienne version.",
    "Payroll.templates.outdatedOne": "1 employé a encore l'ancienne version.",
    "Payroll.templates.reapply": "Réappliquer…",
    "Payroll.templates.reapplyTitle": "Réappliquer « {name} »",
    "Payroll.templates.reapplySame": "identique à l'ancienne version",
    "Payroll.templates.reapplyReplaces": "Réappliquer remplacerait : {labels}",
    "Payroll.templates.reapplyFuture": "S'applique aux paies à venir. Les paies déjà finalisées ne changent pas.",
    "Payroll.templates.reapplyCount": "Réappliquer à {count} employés",
    "Payroll.templates.reapplyCountOne": "Réappliquer à 1 employé",
    "Payroll.templates.reapplyZero": "Réappliquer",
    "Payroll.templates.reapplyNone": "Cochez au moins un employé.",
    "Payroll.templates.reapplyLoadError": "Les réglages des employés n'ont pas pu être chargés.",
    "Payroll.templates.reapplied": "Modèle réappliqué",
    "Payroll.templates.later": "Plus tard",
    "Payroll.templates.summaryService": "Services",
    "Payroll.templates.summaryProduct": "Produits",
    "Payroll.templates.summaryOther": "Autres ventes",
    "Payroll.templates.summaryMargin": "après coûts",
    "Payroll.templates.summarySale": "prix vendu",
    "Payroll.templates.summaryTiers": "paliers {min} à {max}",
    "Payroll.templates.summaryTiersOne": "paliers {rate}",
    "Payroll.templates.summaryExceptions": ", {count} exceptions",
    "Payroll.templates.summaryExceptionsOne": ", 1 exception",
    "Payroll.templates.summaryNone": "Aucune commission réglée",
  },
};
